import gsap from 'gsap';
import { isThereСlass, initMagnetBtn, initSplitText, playSplitText, hideSplitText, initFades, playFade, showMagnetBtn, isTouchDevice } from '../common/help_functions';

function initInsightsItemsAnimation() {

    if (isTouchDevice() || window.innerWidth < 1024) {
        return false;
    }

    const items = document.querySelectorAll('.insights-items .insights-item');
    const strength = 100, angle = 22;

    items.forEach((magnet) => {
        magnet.addEventListener('mousemove', moveMagnet);
        magnet.addEventListener('mouseenter', moveMagnet);
        magnet.addEventListener('mouseleave', leaveMagnet);
    });

    function moveMagnet(event) {
        const magnetImageWrapp = event.currentTarget.querySelector('.insights-item__image')
        const bounding = magnetImageWrapp.getBoundingClientRect()
        const wh = bounding.height,
            ww = bounding.width,
            rotateY = (event.offsetX - (ww * 0.5)) / ww * angle,
            rotateX = (event.offsetY - (wh * 0.5)) / wh * -angle;

        gsap.to(magnetImageWrapp, {
            rotateX: -rotateX,
            rotateY: -rotateY,
            x: (((event.clientX - bounding.left) / magnetImageWrapp.offsetWidth) - 0.5) * strength,
            y: (((event.clientY - bounding.top) / magnetImageWrapp.offsetHeight) - 0.5) * strength,
            z: 80,
            scale: 1.15,
            opacity: 1,
            pointerEvents: 'all',
            ease: 'none',
            duration: 0.4
        });

    }

    function leaveMagnet(event) {
        gsap.to(event.currentTarget.querySelector('.insights-item__image'), {
            x: 0,
            y: 0,
            scale: 0.4,
            opacity: 0,
            pointerEvents: 'none',
            ease: 'none',
            duration: 0.4,
        })
    }
}

function initInsightsTextAnimation() {
    playSplitText('.insights-title', true)
    playFade('.insights-subtitle')
    showMagnetBtn('.insights-btn')
    playFade('.insights-item')
}

export function initInsightsSection() {
    initInsightsItemsAnimation();
    initInsightsTextAnimation();
}


// WEBPACK FOOTER //
// ./src/js/custom/insights.js